// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"512":"a6112128","703":"b9f0f0ab","711":"a8545707"}[chunkId] + ".chunk.css";
};